<template>
  <div class="partyterminal">
    <div class="header">
      <!-- <div class="title">智慧党建平台终端覆盖</div> -->
      <img :src="mobileparty1" alt="">
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div>{{ item.title }}</div>
          <img :src="item.logo" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilepartyterminal1 from "../../../assets/party/mobilepartyterminal1.png";
import mobilepartyterminal2 from "../../../assets/party/mobilepartyterminal2.png";
import mobilepartyterminal3 from "../../../assets/party/mobilepartyterminal3.png";

import mobileparty1 from '../../../assets/party/mobileparty1.png'

export default {
  setup() {
    return reactive({
      mobileparty1:mobileparty1,
      list: [
        {
          id: 1,
          title: "PC端",
          logo: mobilepartyterminal1,
        },
        {
          id: 2,
          title: "移动端",
          logo: mobilepartyterminal2,
        },
        {
          id: 3,
          title: "终端设备",
          logo: mobilepartyterminal3,
        },
      ],
    });
  },
};
</script>

<style scoped>
.partyterminal {
  width: 100%;
  margin: 24px auto 0;
}
.header {
  text-align: center;
}
.header img {
  width: 144px;
  margin: 0 auto;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #a2231d;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .list .item {
  width: 93px;
  padding: 8px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 20px 20px;
  text-align: right;
}
.body .list .item:nth-of-type(2) img {
  width: 24px;
}
.body .list .item div {
  font-size: 12px;
  color: #3d3d3d;
  text-align: left;
}
.body .list .item img {
  width: 60px;
  margin-top: 5px;
  
}
</style>
